import Vue from 'vue'
import VueRouter from 'vue-router'
import router from './router'
import underscore from 'vue-underscore';
import store from './store'
import VueLocalStoragee from 'vue-ls';
import Axios from 'axios'
import VAxios from 'vue-axios'
import Vuelidate from 'vuelidate'

import App from './App.vue'
import vuetify from './plugins/vuetify'
import Def from "./components/default"
import Space from "./components/Cards/Space"
import Ndiv from "./components/Cards/Ndiv"
import Bt from "./components/Additional/Btn-toggle"
import Bt2 from "./components/Additional/Btn-toggle2"


import 'material-design-icons-iconfont/dist/material-design-icons.css'

Vue.use(Vuelidate)
Vue.use(VueLocalStoragee, 'vuejs__');
Vue.use(VueRouter)
Vue.use(VAxios, Axios)
Vue.use(underscore);
Vue.component('Def', Def)
Vue.component('Bt2', Bt2)
Vue.component('Bt', Bt)
Vue.component('Space', Space)
Vue.component('Ndiv', Ndiv)
Vue.config.productionTip = false
Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

//Vue.filter('emogi', function (value) {
//return value.replace('огонь', '&#128293;')
//})
new Vue({
  vuetify,
  store,
  render: h => h(App),
  router
}).$mount('#app')
